/**
 * Helper function to convert various timestamp formats to milliseconds
 */
export function timestampToMillis(timestamp: any): number {
  if (typeof timestamp === 'number') {
    return timestamp;
  }
  if (timestamp instanceof Date) {
    return timestamp.getTime();
  }
  if (timestamp && typeof timestamp === 'object') {
    if ('toMillis' in timestamp && typeof timestamp.toMillis === 'function') {
      return timestamp.toMillis();
    }
    if ('seconds' in timestamp) {
      return timestamp.seconds * 1000;
    }
    if ('toDate' in timestamp && typeof timestamp.toDate === 'function') {
      return timestamp.toDate().getTime();
    }
  }
  // Fallback: try to parse as date
  return new Date(timestamp).getTime();
}
